import { ofType } from "redux-observable";
import { combineLatest, EMPTY, of } from "rxjs";
import { delay, filter, switchMap, take } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { selectTutorialConfig } from "../../../selectors/selectTutorial";
import { utilPersistence } from "../../../utils/utilPersistence";
import { utilProduction } from "../../../utils/utilProduction";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { TypeActionLoading } from "../../loading/actionLoading";
import { IdAssetBundleCore } from "../../loading/IdAssetBundleCore";
import { TypeActionScene } from "../../scenes/actionScenes";
import { IdScene } from "../../scenes/types/IdScene";
import { actionTutorialInit, actionTutorialSelect } from "../actionTutorial";
import { IdTutorialStep } from "../IdTutorialStep";
export var epicTutorialStart = function (action$, state$, deps) {
    var loadingComplete$ = action$.pipe(ofType(TypeActionLoading.Complete), filter(function (action) {
        return action.bundleId === IdAssetBundleCore.Initial && action.isLoaded;
    }));
    var playerInfoReceived$ = action$.pipe(filter(function (action) {
        return action.type === TypeActionPlayerInfo.Received && action.playerInfo.level === 1;
    }));
    var sceneSwap$ = action$.pipe(filter(function (action) {
        return action.type === TypeActionScene.Swap && action.sceneId === IdScene.PlayerBase;
    }));
    return combineLatest(loadingComplete$, playerInfoReceived$, sceneSwap$).pipe(take(1), delay(500), switchMap(function () {
        var tutorialData = utilPersistence.getValue(IdPersistence.Tutorial, {
            tutorialStep: undefined,
        });
        var produceWildflowersStep = selectTutorialConfig(state$.value, IdTutorialStep.sowWildflowers_clickAcre);
        // This is necessary for recipe select on sow windflower tutorial step
        utilProduction.setProductionRecipe(produceWildflowersStep.recipeId, produceWildflowersStep.buildingId);
        var tutorialStep = tutorialData.tutorialStep || IdTutorialStep.welcome_clickConfirmButton;
        if (tutorialStep != undefined) {
            var action = tutorialStep === IdTutorialStep.welcome_clickConfirmButton
                ? actionTutorialSelect(tutorialStep)
                : actionTutorialInit(tutorialStep);
            return of(action);
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialStart.ts
// module id = 2497
// module chunks = 3